<label [class.kal-option-group__disabled]="disabled">{{label}}</label>
<ng-content></ng-content>
